export const environment = {
  production: true,
  // _url:'http://192.168.130.109:8000' 
  _url: 'https://jobworld.ai/api'
};